import type {
  KnowledgeWikiDetail,
  KnowledgeWikiFilter,
  KnowledgeWikiListResponse,
  KnowledgeWikiUpdateInput,
} from '../../types/knowledge-wiki.js';
import { request } from './_request.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business knowledge-wiki APIクライアント。コーディング規約ドキュメントの一覧・詳細を取得する
 * @graph-connects /knowledge-wiki/documents [calls] ドキュメント一覧API
 * @graph-connects /knowledge-wiki/documents/:id [calls] ドキュメント詳細・更新API
 */
export const knowledgeWikiApi = {
  list: (filter: KnowledgeWikiFilter = {}): Promise<KnowledgeWikiListResponse> => {
    const query = new URLSearchParams();
    if (filter.locale) query.set('locale', filter.locale);
    if (filter.category) query.set('category', filter.category);
    if (filter.tagId) query.set('tagId', filter.tagId);
    if (filter.q) query.set('q', filter.q);
    if (filter.incompleteOnly) query.set('incompleteOnly', 'true');
    const qs = query.toString();
    return request<KnowledgeWikiListResponse>(`/knowledge-wiki/documents${qs ? `?${qs}` : ''}`);
  },
  getDetail: (id: string, locale?: string): Promise<KnowledgeWikiDetail> => {
    const qs = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    return request<KnowledgeWikiDetail>(`/knowledge-wiki/documents/${encodeURIComponent(id)}${qs}`);
  },
  update: (id: string, input: KnowledgeWikiUpdateInput): Promise<KnowledgeWikiDetail> => {
    return request<KnowledgeWikiDetail>(`/knowledge-wiki/documents/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
  },
};
